module.exports = __webpack_public_path__ + "static/media/NIGHTBANE    -logo.ac70ce04.png";